import { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@growtherapy/sprout-ui';

export function FormListItemLayout({
  buttonProps: { className: buttonClassName, ...buttonProps } = {},
  children,
  className: containerClassName,
  ...containerProps
}: {
  buttonProps?: HTMLAttributes<HTMLButtonElement>;
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('list-none m-0 p-0', containerClassName)} {...containerProps}>
      <button
        className={cn(
          'relative flex w-full items-center space-x-4 py-4 text-start border-b border-border-default hover:bg-surface-state-inactive-inverse',
          buttonClassName,
        )}
        {...buttonProps}
      >
        {children}
      </button>
    </div>
  );
}
